import React from "react";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
//import { DataGrid /* , GridToolbarContainer, GridToolbarExport */,} from "@material-ui/data-grid";
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from "@material-ui/core/styles";

const theme = createTheme({
  typography: {
    fontSize: 13,
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .super-app-theme--header": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.text,
      fontSize: 16,
    },
    row: {
      backgroundColor: '#f2f2f2',
    }
  },
}));

/* function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
} */

export default function Data_Grid(props) {
  const {
    rows,
    columns,
    checkboxSelection,
    hideFooterPagination,
    rowHeight,
    Width,
    Height,
    ...reset
  } = props;
  // <rows className={classes.row} {...props} />

  const classes = useStyles();
  // <Data_Grid className={classes.row} {...props} />

  return (
    <div
      style={{
        width: Width,
        height: Height,
        marginTop: 3,
        overflow: "hidden",
        position: "relative",

      }}
      className={classes.root}
    >
      <ThemeProvider theme={theme}>
        <DataGrid
          rows={rows}
          columns={columns}
          checkboxSelection={checkboxSelection}
          hideFooterPagination={hideFooterPagination}
          headerHeight={34}
          rowHeight={rowHeight}
          /* components={{
            Toolbar: CustomToolbar,
          }} */
          {...reset}
        // TabelBody={rows.map((row) => (
        //   <TableRow key={row.id} />
        // ))}
        /* onSelectionChange={e => console.log(e.rows)} */
        />
      </ThemeProvider>
    </div>
  );
}
